import { Injectable, inject } from "@angular/core";
import { AbstractControl, ValidationErrors } from "@angular/forms";
import { AsyncValidator, registerAsyncValidatorDecorator } from "@recursyve/ngx-form-generator";
import { Observable, of, timer } from "rxjs";
import { map, switchMap } from "rxjs/operators";
import { ApiService } from "../../../../../../api/api.service";

export function CourseNameExists() {
    return registerAsyncValidatorDecorator({
        name: "CourseNameExistsValidator"
    });
}

@Injectable()
export class CourseNameExistsValidator extends AsyncValidator {
    private readonly apiService = inject(ApiService);

    public readonly name = "CourseNameExistsValidator";

    public validate(control: AbstractControl): Observable<ValidationErrors | null> {
        if (!control.value || control.value === "") {
            return of(null);
        }

        return timer(200).pipe(
            switchMap(() =>
                this.apiService.courses.nameAlreadyUsed(control.value).pipe(
                    map((isNewCourseNameValid) => {
                        if (!isNewCourseNameValid) {
                            control.markAsTouched();
                            return {
                                course_name_already_used: true
                            };
                        }
                        return null;
                    })
                )
            )
        );
    }
}
